import React from 'react';
import * as settingsService from 'services/settings-service';
import { setting } from 'services/settings-service';
import { useTenantContext } from './tenantContext';

interface ISettingsContext {
    getSetting: <T>(key: keyof setting) => T;
    updateSetting: <T>(key: keyof setting, value: T) => void;
    settings: setting;
    getSettings: () => void;
}

const SettingsContext = React.createContext<ISettingsContext>({
    getSetting: <T,>() => null as T,
    updateSetting: <T,>() => null as T,
    settings: {} as setting,
    getSettings: () => void 0
});

export const SettingsProvider = ({ children }: any) => {
    const [settings, setSettings] = React.useState<setting>({} as setting);
    const { currentTenant } = useTenantContext();

    React.useEffect(() => {
        if (!currentTenant) return;
        console.log('settingsTenant', currentTenant)
        settingsService.getSettings().then((resp: typeof settings) => {
            console.log('settingsTenant val', resp)
            setSettings(resp);
        });
    }, [currentTenant])

    const getSetting = <T,>(key: keyof typeof settings): T => {
        const value = settings[key];
        if (value) {
            return settings[key] as T;
        }
        return null as T;
    }

    const updateSetting = <T,>(key: keyof typeof settings, value: T) => {
        const temp  = { ...settings, [key]: value };
        setSettings(temp);
    }

    const getSettings = () => {
        settingsService.getSettings().then((resp: typeof settings) => {
            setSettings(resp);
        });
    }

    const value: ISettingsContext = {
        getSetting,
        updateSetting,
        settings,
        getSettings
    }

    return (
        <SettingsContext.Provider value={value}>
            {children}
        </SettingsContext.Provider>
    )
};

export const useSettingsContext = () => React.useContext(SettingsContext);